import { FileCard } from 'components';
import { AttachedDocument } from 'types';
import styles from './FileList.module.scss';

type DocumentProps = {
    documents: AttachedDocument[],
    onClick: (document: AttachedDocument) => Promise<void>
};

const FileList = ({ documents, onClick }: DocumentProps) => (
    <div className={styles.container}>
        {documents.map((doc) => (
            <FileCard
                key={doc.documentID}
                fileName={doc.documentName}
                document={doc}
                onClick={onClick}
            />
        ))}
    </div>
);

export default FileList;